<template>
  <div class="authorities">
  <FunctionTitle :title="title" />
    <CommonFlame :title="title">
      <template v-if="!$vuetify.breakpoint.xs && authority_flag" v-slot:app-bar-btn>
        <v-btn color="primary" dark @click="linkToNewAuthority()"><v-icon>mdi-plus</v-icon>権限を追加</v-btn>
      </template>
      <v-container > 
        <div class="table-container mt-4">
          <v-data-table
            locale="ja-JP"
            :headers="headers"
            :items="authorities"
            :mobile-breakpoint="240"
            hide-default-footer
            disable-filtering
            disable-pagination
            disable-sort
            no-data-text="データがありません。"
          >
          <template v-slot:item="{ item }">
              <tr> 
                <td>{{ item.id }}</td>
                <td @click="$router.push({ name: 'authority_user_index', params: { id: item.id }})">{{ item.name }}</td>
                <td>
                  <template v-if="authority_flag">
                  <v-icon class="ma-1" color="secondary" @click="linkToEditAuthority(item.id)">mdi-pencil</v-icon>
                    <TemplateDeleteDialog onlyIcon ref=“deleteDialog”>
                      <template v-slot:button>
                        <v-btn class="ma-1" @click="deleteAuthority(item.id)" dense dark color="red"> 削除する </v-btn>
                      </template>
                    </TemplateDeleteDialog>
                  </template>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-container>
    </CommonFlame> 
  </div>
</template>

<script>
import errorHandling from "../../helper/errorHandling";
import axios from 'axios';
import authenticate from "../../helper/authenticate";
import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import TemplateDeleteDialog from "../shared/TemplateDeleteDialog.vue"

  export default {
    components: {
      FunctionTitle,
      CommonFlame,
      TemplateDeleteDialog,
	  },
    data() {
      return{
        authorities:[],
        authority_flag: false,
        title:"権限一覧",
        headers: [
          { text: "権限番号",value: "id", width:"100px"},
          { text: "権限名", value: "name", width:"280px" },
          { text: "", value: "", width:"50px"},
			  ],
      }
    },

    mounted(){
      authenticate.authenticateUser();
      const headers = authenticate.setHeader();
      axios
        .get("/erp/v1/authorities", { headers })
        .then((res) => {
          this.authorities = res.data.authorities
          this.authority_flag = res.data.authority_flag
        })
        .catch((err) => {
          errorHandling.errorResponse(err);
        });
    },


    methods: {
      linkToEditAuthority(id){
        this.$router.push({name: "authority_edit", params: { id }})
      },

      linkToNewAuthority(){
        this.$router.push({name: "authority_new"})
      },

      deleteAuthority(id){
        authenticate.authenticateUser();
        const headers = authenticate.setHeader();
        const delete_id = id
        axios
          .delete(`/erp/v1/authorities/${delete_id}`, { headers })
          .then((res) => {
            this.$router.go({path: this.$router.currentRoute.path})
            this.$store.commit("setFlash", {
            text: "削除しました",
            type: "notice",
          });
          })
          .catch((err) => {
            errorHandling.errorResponse(err);
          });
        }
    }
  }

</script>